import styled from "@emotion/styled";
import Call from "@components/icons/Call";
import { theme } from "@styles/theme";
const { md } = theme.breakpoints;
export const Container = styled.div`
  background-color: #0085c8;
  display: flex;
  @media (max-width: ${md}) {
    font-size: 12px;
  }
`;
export const Logo = styled.div`
  cursor: pointer;
  background-color: white;
  display: flex;
  align-items: center;
`;
export const Img = styled.img`
  width: 83%;
  margin: 0 auto;
`;
export const ItemGroup = styled.ul`
  flex-grow: 3;
  display: flex;
  padding-left: 2em;
`;
export const IconCall = styled(Call)`
  margin-right: 0.75em;
  width: 1em;
`;
export const Item = styled.a`
  color: white;
  list-style-type: none;
  display: flex;
  align-items: center;
  margin: 0 0.9375em;
  font-family: Poppins Ligth;
  font-size: 0.8em;
`;
